<template>
  <primary-main ref="primaryMainRef" 
    api-bar-path="one_level_tree_overall" 
    api-pie-path="one_level_overall" 
    :getCommonParams="getCommonParams" 
    :showFieldOption="showFieldOption" 
    :pageType="pageType"
    :toSubPage="toSubPage"
    :resourceType="resourceType">
    <filter-form ref="filterFormRef" :showFieldOption="showFieldOption" :pageType="pageType" :resourceType="resourceType" @ensure="onFilterEnsure" @threshold-submited="onThresholdSubmited" />
  </primary-main>
</template>

<script>
import {ref, provide, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import FilterForm from './filter-form.vue'
import PrimaryMain from './main.vue'

function sleep(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
}

export default {
  components: {FilterForm, PrimaryMain},
  props: {pageType: String, resourceType: Number, subPageRoute: String},

  setup(props) {
    const route = useRoute(),
      router = useRouter(),
      projectId = route.query.project,
      showFieldOption = projectId == 7 ? 
        ['Triangles', 'MaxDrawCalls', 'AssetBundleSize', 'AssetMemorySize', 'MeshCollider'].map(item => ({label: item, value: item})) :
        ['AveVertCount', 'AveDCCount', 'AveTrisCount', 'MaxVertCount', 'MaxDCCount', 'MaxTrisCount', 'MaxPsysCount', 'AveParticleCount', 'MaxParticleCount', 'AvePsysCount'].map(item => ({label: item, value: item})),
      filterFormRef = ref(null),
      primaryMainRef = ref(null)

    function onFilterEnsure(form, qualityLevelOption) {
      primaryMainRef.value.onSubmit(form, qualityLevelOption)
    }

    async function onThresholdSubmited(form, qualityLevelOption) {
      await sleep(100)
      primaryMainRef.value.onSubmit(form, qualityLevelOption)
    }

    function getFlagParams(showField) {
      let result = {}

      showFieldOption.forEach(option => {
        if (showField.includes(option.value)) {
          result[`Flag_${option.value}`] = 1
        } else {
          result[`Flag_${option.value}`] = 0
        }
      })
      return result
    }

    function getCommonParams(PartQuality, filterForm) {
      const {
        Versions,
        ScanTime,
        PartType,
        AssetType,
        AssetSubType,
        showField,
        rarity,
        is_filter_white,
        isComplete,
      } = filterForm.value;
      let result = {
        project: route.query.project,
        Versions,
        ScanTime,
        PartType,
        AssetType,
        AssetSubType,
        PartQuality,
        rarity,
        ...getFlagParams(showField),
        Flag_Overall: 0,
        resource_type: props.resourceType,
        is_filter_white: is_filter_white ? 1 : 0,
        isComplete,
      };

      return result;
    }

    function toSubPage({grade, field, range, quality, filterForm} = {}) {
      const {Versions, ScanTime, AssetType, AssetSubType, PartQuality, PartType, showField, rarity} = filterForm.value || filterForm
      const params = encodeURIComponent(JSON.stringify({
          version: Versions,
          testTime: ScanTime,
          assetType: AssetType,
          assetSubType: AssetSubType,
          partQuality: quality,
          partType: PartType,
          filterItem: field,
          filterOption: grade ? '2' : '1',
          grade,
          range,
          rarity
        }))

      const link = router.resolve({
        name: props.subPageRoute,
        query: {params}
      })

      window.open(link.href, '_blank')
    }

    onMounted(async() => {
      const {formData, qualityLevelOption} = await filterFormRef.value.getFilterOptions()
      primaryMainRef.value.init(formData, qualityLevelOption)
    })

    return {primaryMainRef, filterFormRef, showFieldOption, onFilterEnsure, onThresholdSubmited, getCommonParams, toSubPage}
  }
}
</script>